<div class="main-body">
  <kendo-appbar [position]="'top'" themeColor="light" class="margin-right-10">
    <kendo-appbar-section>
      @if (user != null) {
        <button kendoButton themeColor="primary" fillMode="flat" icon="menu" (click)="toggleDrawer()"></button>
      }
      <!--      <button kendoButton *ngIf="user != null && user.finished_signup" themeColor="primary"-->
    <!--              look="flat" icon="menu" (click)="toggleDrawer()"></button>-->
    <!--      <img src="/assets/2024-11-07%2016.00.02.jpg" class="top-left-logo" (click)="home()"/>-->
    <h1 [style.margin-left.px]="10" class="title" style="cursor: pointer">Smart ADiE DE</h1>
  </kendo-appbar-section>
  <kendo-appbar-spacer></kendo-appbar-spacer>
  @if (user != null) {
    <kendo-appbar-section>
      Welcome, {{user.firstname}} {{user.lastname}}
    </kendo-appbar-section>
  }
  @if (user != null) {
    <kendo-appbar-section class="actions">
      <kendo-badge-container>
        <button class="k-button k-button-clear" (click)="home()">
          <kendo-icon [name]="'home'"></kendo-icon>
        </button>
      </kendo-badge-container>
      <span class="k-appbar-separator"></span>
      <span class="k-appbar-separator"></span>
      <kendo-appbar-spacer [width]="'10px'"></kendo-appbar-spacer>
      <kendo-badge-container>
        <button class="k-button k-button-clear background-primary margin-right-15" (click)="logout()">
          <kendo-icon [name]="'logout'"></kendo-icon>
        </button>
      </kendo-badge-container>
    </kendo-appbar-section>
  }
</kendo-appbar>
<div kendoDialogContainer></div>
  @if(loader.loading()){
    <div class="global-loader">
      <kendo-loader
        type="infinite-spinner"
        themeColor="primary"
        size="large">
      </kendo-loader>

      <div style="margin-top:12px; font-weight:500;">
        {{ loader.message() }}
      </div>
    </div>
  }
<router-outlet></router-outlet>
</div>
<kendo-appbar class="bottom-appbar center-center" [position]="'bottom'" [themeColor]="'light'">
  <span class="notes center-text">v{{version}} &copy; 2025 Care Directives</span>
</kendo-appbar>
